type Formatter = (text: React.ReactNode) => React.ReactNode

export const p: Formatter = (text) => (
  <>
    {text}
    <br />
  </>
)

export const ul: Formatter = (text) => (
  <ul style={{ marginLeft: '24px' }}>{text}</ul>
)

export const li: Formatter = (text) => <li>{text}</li>

export const email: Formatter = (text) => <a href={`mailto:${text}`}>{text}</a>

export const bold: Formatter = (text) => (
  <span style={{ fontWeight: 700 }}>{text}</span>
)

export const br: Formatter = () => <br />

export const u: Formatter = (text) => <u>{text}</u>

export const red: Formatter = (text) => (
  <span className='text-red-600'>{text}</span>
)
